// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"64":"44cd9573","235":"70e595f1","329":"aa59fc8b","364":"ddb43aeb","925":"cfea342f"}[chunkId] + ".js";
};